export const months = [
    { id: 1, title: 'january' },
    { id: 2, title: 'february' },
    { id: 3, title: 'march' },
    { id: 4, title: 'april' },
    { id: 5, title: 'may' },
    { id: 6, title: 'june' },
    { id: 7, title: 'july' },
    { id: 8, title: 'august' },
    { id: 9, title: 'september' },
    { id: 10, title: 'october' },
    { id: 11, title: 'november' },
    { id: 12, title: 'december' },
];
const adultLowYear = new Date().getFullYear() - 110;
const adultHighYear = new Date().getFullYear();
const adultListYear = [];
for (let i = adultLowYear; i <= adultHighYear; i++) {
    adultListYear.push(i);
}
export const fullYearList = adultListYear
    ?.map((a) => ({
    id: a,
    title: a.toString(),
}))
    .reverse();
//# sourceMappingURL=defaultLists.js.map